// eslint-disable-next-line import/no-named-default
import StandardChart from './core/StandardChart';
import { debug } from './util/debug';
import { version as VERSION } from '../package.json';

/**
 * 初始化一个图表组件
 */
export function init(...args: ConstructorParameters<typeof StandardChart>) {
  debug('init: %o', args);

  if (typeof args[0] === 'string') {
    if ((args[0] as string).startsWith('.') || (args[0] as string).startsWith('#')) {
      args[0] = document.querySelector(args[0]);
    } else {
      args[0] = document.querySelector(`#${args[0]}`);
    }
  }
  if (!args[0]) {
    throw new Error(`"dom" should be an selector or an HTMLElement.`);
  }

  const chart = new StandardChart(...args);
  (chart as unknown as { version: string }).version = VERSION;

  return chart;
}
